import SubcategoryListItemDesktop from './subcategory-list-item-desktop';
import SubcategoryListItemMobile from './subcategory-list-item-mobile';
import forDevice from '../../hoc/for-device';

export default forDevice(SubcategoryListItemMobile, SubcategoryListItemDesktop);
